import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import AdminPage from '../../admin/shared/AdminPage'
import NavTile from '../shared/NavTile'

function OrchestratorHome ({ root }) {
  return (
    <AdminPage>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <NavTile to={`${root}/orchestration/scheduler`} label='Scheduler' />
        </Grid>
      </Grid>
    </AdminPage>
  )
}

OrchestratorHome.propTypes = {
  root: PropTypes.any
}

export default OrchestratorHome
